import LRUMap from './LRU';
import ES6Set from './set';
import * as styleHelper from '../canvas/style';
var textSizeLRUMap = new LRUMap(3000);
var defaultContext;
var canvasContextPool = new ES6Set();
function getDefaultContext() {
    if (!defaultContext) {
        var canvas = document.createElement('canvas');
        defaultContext = canvas.getContext('2d');
    }
    return defaultContext;
}
export function getContext() {
    return canvasContextPool.values().next().value || getDefaultContext();
}
export function addContext(ctx) {
    canvasContextPool.add(ctx);
}
export function removeContext(ctx) {
    canvasContextPool.delete(ctx);
}
export function measureTextList(textList, textStyle, ctx) {
    if (textStyle === void 0) { textStyle = {}; }
    if (ctx === void 0) { ctx = getContext(); }
    ctx.save();
    initTextContext(ctx, textStyle);
    var sizeList = textList.map(function (text) { return measureText(text, textStyle, ctx, false); });
    ctx.restore();
    return sizeList;
}
export function measureText(text, textStyle, ctx, setContext) {
    if (textStyle === void 0) { textStyle = {}; }
    if (ctx === void 0) { ctx = getContext(); }
    if (setContext === void 0) { setContext = true; }
    var cacheKey = getCacheKey(text, textStyle);
    var cacheSize = textSizeLRUMap.get(cacheKey);
    if (cacheSize) {
        return cacheSize;
    }
    setContext && ctx.save();
    setContext && initTextContext(ctx, textStyle);
    var width = ctx.measureText(text).width;
    var height = textStyle.fontSize;
    var size = { width: width, height: height };
    textSizeLRUMap.set(cacheKey, size);
    setContext && ctx.restore();
    return size;
}
function initTextContext(ctx, textStyle) {
    if (textStyle === void 0) { textStyle = {}; }
    var _a = textStyle.fontFamily, fontFamily = _a === void 0 ? 'sans-serif' : _a, _b = textStyle.fontSize, fontSize = _b === void 0 ? 12 : _b, _c = textStyle.fontWeight, fontWeight = _c === void 0 ? 'normal' : _c, _d = textStyle.fontStyle, fontStyle = _d === void 0 ? 'normal' : _d;
    styleHelper.setFontStyle(ctx, fontSize, fontFamily, fontWeight, fontStyle);
}
function getCacheKey(text, textStyle) {
    var _a = textStyle.fontFamily, fontFamily = _a === void 0 ? 'sans-serif' : _a, _b = textStyle.fontSize, fontSize = _b === void 0 ? 10 : _b, _c = textStyle.fontWeight, fontWeight = _c === void 0 ? 'normal' : _c, _d = textStyle.fontStyle, fontStyle = _d === void 0 ? 'normal' : _d;
    return [text, fontSize, fontFamily, fontWeight, fontStyle].join('__$$__');
}
